import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

export const reactPlugin = new ReactPlugin()

// eslint-disable-next-line no-underscore-dangle
let _ai

const applicationInsights = {
  init: (connectionString) => {
    if (!_ai) {
      _ai = new ApplicationInsights({
        config: {
          connectionString,
          extensions: [reactPlugin],
          enableAutoRouteTracking: false,
          disablePageUnloadEvents: ['visibilitychange'],
        },
      })
      _ai.loadAppInsights()
    }
  },
  ai: () => _ai,
}

export default applicationInsights
